import queryString from 'query-string';
import { TweenLite } from 'gsap/TweenLite';
import _debounce from 'lodash/debounce';
import createEvent, { createCustomEvent } from '@/scripts/utils/create-event';
import DoubleTextBtn from '@/scripts/elements/DoubleTextBtn';
import HoverDistortion from '@/scripts/elements/HoverDistortion';
import { DOCUMENT_ELEMENT } from '@/scripts/constants';
import NProgress from 'nprogress';

import './PageFilters.scss';

const defaults = {
  element: null,
  pagination: '[data-role*="pagination"]',
  filters: '[data-role*="filters"]',
  content: '[data-role*="content"]',
  activeClass: 'is-active',
  loadingClass: 'is-loading',
};

export default class PageFilters {
  constructor(props) {
    const options = Object.assign({}, defaults, props);
    this.$element = $(options.element);
    if (!this.$element.length || !history.pushState) return;

    this.paginationSelector = options.pagination;
    this.contentSelector = options.content;

    this.$pagination = this.$element.find(this.paginationSelector);
    this.$content = this.$element.find(this.contentSelector);
    this.$filters = this.$element.find(options.filters);

    this.loadingClass = options.loadingClass;
    this.activeClass = options.activeClass;
    this.loading = false;

    this.transitionDuration = document.documentElement.dataset.duration;

    this.loaded = false;

    this.init();
  }

  static get location() {
    return window.location.href;
  }

  scrollToTop() {
    return TweenLite.to(
      window,
      this.transitionDuration,
      { scrollTo: { y: this.$content.offset().top - 300, autoKill: false } },
    );
  }

  onPopstate() {
    const link = { query: queryString.parseUrl(PageFilters.location).query, backButton: true };
    this.doLoading(link);
  }

  doLoading(link) {
    if (this.loading) location.reload();
    this.loading = true;
    this.$element.addClass(this.loadingClass);
    NProgress.start();

    if (this.loaded) {
      this.scrollToTop();
    }


    const { query } = link;

    const url = `${this.$element.data('url')}?${queryString.stringify(query, { arrayFormat: 'bracket' })}`;


    this.destroyInteractive();

    $.ajax({
      accept: 'text/html',
      contentType: 'application/json',
      context: this,
      type: 'GET',
      error: this.onPageLoadFailure,
      success(data) {
        this.loaded = true;
        this.onPageLoadSuccess(data, Object.assign({}, link, { href: `${location.pathname}?${queryString.stringify(query)}` }));
      },
      url,
    });
  }

  destroyInteractive() {
    this.$content.find('[data-role="hover-distortion"]')
      .each((i, element) => {
        element.dispatchEvent(createEvent('destroy'));
      });
  }

  initButtons() {
    this.$content.find('[data-role*="double-text-btn"]')
      .each((i, button) => new DoubleTextBtn(button));
  }

  initInteractive() {
    this.$content.find('[data-role="hover-distortion"]')
      .each((i, element) => new HoverDistortion({
        element,
        intensity: 0.2,
      }));

    DOCUMENT_ELEMENT.dispatchEvent(createCustomEvent('updateVideoModalTriggers', {
      detail: {
        triggers: this.$content.find('[data-role*="video-modal-trigger"]').toArray(),
      },
    }));
  }

  onSubmit() {
    this.$filters.find('[data-role="dropdown-container"]').trigger('dropdown-toggle');
    const formParams = this.$filters.serialize();

    this.doLoading({ query: queryString.parse(formParams) });
  }

  onPageLoadFailure() {
    this.$element.removeClass(this.loadingClass);
    this.loading = false;
    NProgress.done();
  }

  onPageLoadSuccess(data, link) {
    if (link && !link.backButton) history.pushState('', '', link.href);

    this.updateFilters(queryString.parseUrl(link.href).query);

    const $data = $(data);
    const $content = $($data.find(this.contentSelector).html());
    const $pagination = $($data.find(this.paginationSelector).html());

    this.$content.html($content);

    if (this.$pagination.length) {
      this.$pagination.html($pagination);
      this.initPagination();
    }

    this.initButtons();
    this.initInteractive();

    setTimeout(() => {
      this.$element.removeClass(this.loadingClass);
      this.loading = false;
      NProgress.done();
    }, 500);
  }

  updateFilters(query) {
    this.$filters.find('input').prop('checked', false);
    Object.keys(query).forEach((key) => {
      const values = [].concat(query[key]);
      values.forEach((value) => {
        this.$filters.find(`input[name="${key}"][value="${value}"]`).prop('checked', true);
      });
    });
  }

  initFilters() {
    this.$filters.find('input').on('change', _debounce(this.onSubmit.bind(this), 100));
  }

  initPagination() {
    const that = this;
    this.$pagination.find('a').on('click', function click(e) {
      e.preventDefault();
      const query = Object.assign(
        {},
        queryString.parseUrl(this.href).query,
        queryString.parse(that.$filters.serialize()),
      );
      that.doLoading({ query });
      return false;
    });
  }

  addEvents() {
    this.initFilters();
    this.initPagination();
    this.$filters.on('submit', () => false);
    window.addEventListener('popstate', this.onPopstate.bind(this));
  }

  init() {
    this.addEvents();
    this.onPopstate();
  }
}



// WEBPACK FOOTER //
// ./scripts/elements/PageFilters/PageFilters.js